import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mt-6 w-full max-w-screen-xl space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "rounded-2xl bg-gradient-to-l from-violet-900 to-indigo-700 px-6 py-7 text-white shadow-sm sm:px-8"
}
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/10" }
const _hoisted_5 = {
  key: 1,
  class: "report-options"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ReportOptionComponent = _resolveComponent("ReportOptionComponent")!
  const _component_GateWaysList = _resolveComponent("GateWaysList")!
  const _component_SystemGateways = _resolveComponent("SystemGateways")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.statusComponent === 'Menu')
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "25" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-bank-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-right" }, [
              _createElementVNode("h1", { class: "text-xl font-bold sm:text-2xl" }, "مدیریت درگاه‌ها"),
              _createElementVNode("p", { class: "mt-1 text-sm text-violet-100" }, "مدیریت درگاه‌های کاربران و سرویس‌های سیستمی")
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.statusComponent === 'Menu')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createBlock(_component_ReportOptionComponent, {
              key: index,
              option: option,
              onClick: ($event: any) => (_ctx.selectedOption(option))
            }, null, 8, ["option", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.statusComponent === 'gateways')
      ? (_openBlock(), _createBlock(_component_GateWaysList, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.statusComponent === 'systemGateways')
      ? (_openBlock(), _createBlock(_component_SystemGateways, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}